import {BaseIdModel} from "common-shared";
import {Exclude, Type} from "class-transformer";
import {DateTime} from "luxon";
import {SortEvent} from "primeng/api";

export class BaseConnectionModel extends BaseIdModel {
  @Type(() => Date)
  FromDate?: Date;
  @Type(() => Date)
  ToDate?: Date;
  IsDefault?: boolean;
  Sequence?: number;
  @Exclude()
  $isNew?: boolean = false;

  isActiveDefault() {
    if (!this.IsDefault) {
      return false;
    }
    const now = DateTime.fromJSDate(new Date()).startOf('day');
    const from = DateTime.fromJSDate(this.FromDate ?? new Date()).startOf('day');
    const to = DateTime.fromJSDate(this.ToDate ?? new Date()).startOf('day');
    return from <= now && now <= to;
  }

  public static getFirstRowNrOfLastPage(totalRows: number, rowsPerPage: number): number {
    let remainder = totalRows % rowsPerPage;
    return totalRows - (remainder ? remainder : rowsPerPage);
  }


  public static sort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      if (data1.$isNew === true) {
        return 1;
      }

      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }
}
